import type { SrSalesOrderType } from '@plato/data/starrocks/types';
import { createContext } from 'react';

export type DialogsContextType = {
    openInsightOutcomeDetails: (outcomeId: string) => void;
    openOrderQuoteDetails: (type: SrSalesOrderType, id: string) => void;
    openProductDetails: (nextProductId: string, customerId?: string) => void;
    openTaskDetails: (taskId: string) => void;
};

export const DialogsContext = createContext<DialogsContextType | undefined>(undefined);
